import React from 'react';
import { alertError } from '../config/toast';
import { getOrdersReq } from '../config/httpRoutes';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Loader from '../components/loader';
import { getFormattedDate } from '../config/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faObjectGroup, faSearch, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import TextInput from '../components/textInput';
import { commaRE } from '../config/regex';
import { destatuser, depaymenter } from '../config/globals';

class Orders extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			allOrders: null,
			orders: null,

			fetchLoading: true,
			loading: false,
			key: ''
		};
	}

	componentDidMount() {
		this.getOrders();
	}

	getOrders = () => {
		this.setState({ fetchLoading: true });
		getOrdersReq()
			.then((res) => {
				this.setState({ allOrders: res.data, orders: res.data });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch orders");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	}

	handleChange = ({ target: { name, value } }) => {
		this.setState({ [name]: value });
	}

	searchOrders = (e) => {
		e.preventDefault();
		let { key } = this.state;
		if (!key) { return; }
		key = key.toLowerCase();
		const { allOrders } = this.state;
		const orders = allOrders.filter((o) =>
			(o.seller?.name?.toLowerCase() || '').indexOf(key) > -1
			|| (o.user?.state?.toLowerCase() || '').indexOf(key) > -1
			|| (o.user?.city?.toLowerCase() || '').indexOf(key) > -1
		);
		this.setState({ orders });
	}
	cancelSearch = () => {
		this.setState((st) => ({ orders: st.allOrders, key: '' }));
	}

	filterDeclined = () => {
		const { allOrders } = this.state;
		const orders = allOrders.filter((o) =>
			o.status == 4
		);
		this.setState({ orders });
	}

	filterPending = () => {
		const { allOrders } = this.state;
		const now = Date.now();
		const orders = allOrders.filter((o) =>
			o.status == 0
			&& (now - o.timestamp) > 86400000
		);
		this.setState({ orders });
	}

	filterPendingEarly = () => {
		const { allOrders } = this.state;
		const now = Date.now();
		const orders = allOrders.filter((o) =>
			o.status == 0
			&& (now - o.timestamp) > 3600000
		);
		this.setState({ orders });
	}

	clearFilters = () => {
		this.setState({ orders: this.state.allOrders });
	}

	render() {
		const { orders, fetchLoading, loading, key } = this.state;
		const { handleChange, searchOrders, cancelSearch, filterDeclined, filterPending, filterPendingEarly, clearFilters } = this;
		return (
			<Row style={{ marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
				<Col md={12} style={{ justifyContent: 'space-between', display: 'flex', marginTop: '10px', marginBottom: '15px' }}>
					<div>
						<Form onSubmit={searchOrders}>
							<Form.Group style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
								<TextInput style={{ flex: 1 }} onChange={handleChange} value={key} name="key" label="Search Orders" icon={
									key ?
										<FontAwesomeIcon icon={faTimes} onClick={cancelSearch} style={{ marginRight: 10, cursor: 'pointer' }} />
										:
										<></>
								} />
								<Button variant="success" type="submit" style={{ width: 40 }} size="sm" disabled={loading}>
									{loading ?
										<FontAwesomeIcon icon={faSpinner} spin />
										:
										<FontAwesomeIcon icon={faSearch} />
									}
								</Button>
							</Form.Group>

						</Form>
					</div>
					<div>
						<Button variant="success" onClick={filterDeclined} size="md" style={{ maxHeight: 40, marginRight: 20 }}>
							<FontAwesomeIcon icon={faFilter} /> Filter declined
						</Button>
						<Button variant="success" onClick={filterPending} size="md" style={{ maxHeight: 40, marginRight: 20 }}>
							<FontAwesomeIcon icon={faFilter} /> Filter Pending from 24h+
						</Button>
						<Button variant="success" onClick={filterPendingEarly} size="md" style={{ maxHeight: 40, marginRight: 20 }}>
							<FontAwesomeIcon icon={faFilter} /> Filter Pending from 1h+
						</Button>
						<Button variant="success" onClick={clearFilters} size="md" style={{ maxHeight: 40 }}>
							<FontAwesomeIcon icon={faObjectGroup} /> Clear Filters
						</Button>
					</div>
				</Col>
				{fetchLoading && <Loader />}
				{Array.isArray(orders) ?
					orders.length > 0 ?
						<div className="table-responsive">
							<table className="table table-hover table-attendance">
								<thead>
									<tr>
										<th>ID</th>
										<th>Date</th>
										<th>User Name</th>
										<th>Admin Name</th>
										<th>Seller Name</th>
										<th>Decliner 1 Name</th>
										<th>Decliner 2 Name</th>
										<th>Deliverer Name</th>
										<th>Products</th>
										<th>Delivery Charges</th>
										<th>Total</th>
										<th>Status</th>
										<th>Payment Status</th>
									</tr>
								</thead>
								<tbody>
									{orders.map(({ id, timestamp, userid, user, admin, seller, dec, dect, deliverer, total, delivered, products, status, payment_status, delivery_charges }, i) =>
										<tr key={i}>
											<td>{id}</td>
											<td>{getFormattedDate(parseInt(timestamp))}</td>
											<td>{user?.name}</td>
											<td>{admin?.name}</td>
											<td>{seller?.name}</td>
											<td>{dec?.name}</td>
											<td>{dect?.name}</td>
											<td>{deliverer?.name || ''}</td>
											<td>{products.map((p, i) =>
												<p key={`p${i}`}>{p.name}({p.quantity})x{p.amount}</p>
											)}</td>
											<td>₹ {delivery_charges?.toString().replace(commaRE, ',') || ''}</td>
											<td>₹ {total?.toString().replace(commaRE, ',') || ''}</td>
											<td>{destatuser[status]}</td>
											<td>{depaymenter[payment_status]}</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
						:
						<p style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}>No orders found.</p>
					:
					<></>
				}
			</Row>
		);
	}
}

export default Orders;